export enum IframeMessageToChildType {
  auth = 'AUTH'
}
